import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { ApplicationDenyPayload } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request'
import { FF, TextareaInput, Toast, Validators, handleFormSubmissionError } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { Dialog, DialogFace } from 'ui/components/Dialog'

import { s } from './styles'

type Props = {
  onClose: () => void
  applicationId: number
  companyIndex: number
}

export const DenyCompanyDialog = (props: Props) => {
  const { onClose, applicationId, companyIndex } = props
  const router = useRouter()

  const { mutateAsync, isPending } = useMutation<void, Error, ApplicationDenyPayload>({
    mutationFn: (props) => Request.put(Request.urls.bank.applicationDeny, props),
    onSuccess: () => {
      onClose()
      router.invalidate()
      Toast.success('Company denied')
    },
    onError: async (error) => {
      handleFormSubmissionError(error, formApi)
    }
  })

  const formApi = useForm({
    defaultValues: { denialReason: '' },
    onSubmit: ({ value: { denialReason } }) =>
      mutateAsync({ denialReason, applicationId, isDenied: true, companyIndex })
  })

  return (
    <Dialog
      id={`DenyCompanyDialog-${companyIndex}`}
      onClose={() => {
        formApi.reset()
        onClose()
      }}
      face={DialogFace.PRIMARY}
      title="Reason for Denial Required"
      isSubmitting={isPending}
      customFooterActions={
        <>
          <Button key="delete" face="danger" loading={isPending} onClick={formApi.handleSubmit} data-qa="dialog-delete">
            Deny
          </Button>
          <Button
            key="cancel"
            face="secondary"
            onClick={() => {
              formApi.reset()
              onClose()
            }}
            data-qa="dialog-cancel"
            disabled={isPending}
          >
            Cancel
          </Button>
        </>
      }
    >
      <s.Box>
        <formApi.Field
          name="denialReason"
          validators={{
            onChange: ({ value }) => Validators.required.field(value)
          }}
          children={(field) => (
            <FF
              required
              label="Reason"
              field={field}
              input={(p) => (
                <TextareaInput hint="The notes will be saved in Internal Notes (only visible to Bank) " {...p} />
              )}
            />
          )}
        />
      </s.Box>
    </Dialog>
  )
}
